module.exports = __webpack_public_path__ + "static/media/Farshad.499fde20.jpeg";